import React, { Component, useEffect, useState } from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  FlatList,
  Animated,
  Alert,
  ImageBackground,
  Platform,
} from "react-native";
import { StackActions, NavigationActions } from "react-navigation";
import { EventRegister } from "react-native-event-listeners";
import Toast from "react-native-tiny-toast";
import Icon from "react-native-vector-icons/FontAwesome";

import {
  getAluno,
  removerTelefone,
  enviarCodigoSMS,
} from "../../services/aluno-service";
import styles from "./styles";
import Loading from "../../components/Loading";
import { alert } from "../../utils/alerts";

const CardTelefone = (props) => {
  const { verificarNumero } = props;

  useEffect(() => {
    Animated.timing(_animated, {
      toValue: 1,
      duration: 300,
      useNativeDriver: true,
    }).start();
  });
  const _animated = new Animated.Value(0);
  const tel = props.tel.item;
  const rowStyles = [styles.personalData, { opacity: _animated }];

  const excluir = async (tel) => {
    const response = await removerTelefone(tel);

    if (!response.ok) console.log(await response.json());

    Animated.timing(_animated, {
      toValue: 0,
      duration: 300,
    }).start();

    setTimeout(() => {
      EventRegister.emit("reloadTelefones", "it works!!!");
    }, 300);

    Toast.show("Telefone removido");
  };

  return (
    <Animated.View style={rowStyles}>
      <View style={styles.body}>
        <View style={styles.containerFone}>
          <View style={{ flex: 1, justifyContent: "center" }}>
            <Text style={[styles.dataProperty, { marginTop: 0 }]}>
              {tel.tipo === "C" ? "CELULAR" : "RESIDENCIAL:"}
            </Text>
            <Text style={styles.dataValue}>
              ({tel.ddd}) {tel.numero}{" "}
              {tel.whatsapp ? (
                <Icon name="whatsapp" size={20} color="#0A0" />
              ) : (
                ""
              )}
            </Text>
            {tel.verificado === 0 ? (
              <>
                {tel.tipo === "C" && (
                  <TouchableOpacity
                    onPress={() => {
                      verificarNumero(tel);
                    }}
                  >
                    <Text style={{ marginTop: 10, color: "red", fontSize: 16 }}>
                      Verificar número
                    </Text>
                  </TouchableOpacity>
                )}
              </>
            ) : (
              <>
                <Text
                  style={{
                    fontFamily: "Montserrat",
                    marginTop: 10,
                    color: "green",
                    fontSize: 16,
                  }}
                >
                  Número verificado
                  <Icon
                    style={[styles.iconToggle, { marginLeft: 5 }]}
                    accessibilityLabel="Telefone Verificado"
                    accessibilityhint="Telefone Verificado"
                    name="check"
                    size={20}
                    color="green"
                  />
                </Text>
              </>
            )}
          </View>

          <TouchableOpacity
            style={styles.iconTrash}
            onPress={() => {
              if (
                Platform.OS === "web" &&
                window.confirm("Deseja realmente excluir esse telefone?")
              )
                excluir(tel);
              else
                Alert.alert(
                  "Confirmar",
                  "Deseja realmente excluir esse telefone?",
                  [
                    {
                      text: "Sim",
                      onPress: () => {
                        excluir(tel);
                      },
                    },
                    {
                      text: "Não",
                      style: "cancel",
                      onPress: console.log("teste"),
                    },
                  ]
                );
            }}
          >
            <Icon
              style={styles.iconToggle}
              name="trash"
              size={30}
              color="#C1C1C1"
            />
          </TouchableOpacity>
        </View>
      </View>
    </Animated.View>
  );
};

function Telefones({ navigation }) {
  const [aluno, setAluno] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const carregarAluno = async () => {
      setAluno(await getAluno(true));
    };

    carregarAluno();

    let listener = EventRegister.addEventListener(
      "reloadTelefones",
      async (data) => {
        setAluno(await getAluno(true));
      }
    );

    return () => {
      EventRegister.removeEventListener(listener);
    };
  }, []);

  const navigateToAdicionarTelefone = () => {
    navigation.navigate("AdicionarCelular");
  };

  const verificarNumero = async (telefone) => {
    setLoading(true);
    const response = await enviarCodigoSMS(telefone.id);

    if (!response.ok) {
      let { erro } = await response.json();
      setLoading(false);
      return alert("Ops...", erro);
    }

    setLoading(false);
    navigation.push("VerificarCodigoSMS", {
      telefoneId: telefone.id,
    });
  };

  return (
    <ImageBackground
      source={require("../../../resources/imgs/bg.jpg")}
      style={[styles.container]}
      imageStyle={styles.imageContainer}
    >
      {loading && <Loading />}
      <TouchableOpacity
        style={styles.botaoAdicionar}
        onPress={navigateToAdicionarTelefone}
      >
        <Text style={styles.botaoTextAdicionar}>Adicionar +</Text>
      </TouchableOpacity>
      <FlatList
        style={{ height: 300 }}
        data={aluno.telefones}
        keyExtractor={(tel) => String(tel.id)}
        showsVerticalScrollIndicator={false}
        renderItem={(tel) => (
          <CardTelefone
            verificarNumero={verificarNumero}
            key={tel.id}
            tel={tel}
          />
        )}
      />
      <Text style={styles.alert}>
        A dica aqui é manter seus contatos sempre atualizados, as oportunidades
        podem aparecer a qualquer momento.
      </Text>
    </ImageBackground>
  );
}
Telefones.navigationOptions = ({ navigation }) => {
  return {
    headerStyle: {
      backgroundColor: "#0F0F0F",
    },
    headerTitleStyle: {
      color: "#FFF",
    },
    headerLeft: () => (
      <TouchableOpacity
        onPress={() => {
          navigation.openDrawer();
        }}
      >
        <Icon
          style={styles.iconHeaderLeft}
          name="reorder"
          size={30}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
    headerRight: () => (
      <TouchableOpacity
        onPress={() => {
          EventRegister.emit("reloadTelefones", "it works!!!");

          Toast.show("Atualizado");
        }}
      >
        <Icon
          style={styles.iconBarRight}
          name="refresh"
          size={20}
          color="black"
        />
      </TouchableOpacity>
    ),
  };
};

export default Telefones;
